<i18n src="Components/02-molecules/product-info-sections/translations"></i18n>

<template>
  <div v-if="items.length !== 0" class="plp-attributes-26">
    <div
      v-for="item in limitedItems"
      :key="itemKey(item)"
      class="attribute-line"
    >
      {{ item.label }}:
      <a
        v-if="item.attributeLink"
        class="value-link"
        :href="item.attributeLink"
        :data-testid="`attribute-link-${item.id}`"
        >{{ item.info }}</a
      >
      <span v-else>{{ item.info }}</span>
    </div>

    <a v-if="hasOverflow && productUrl" class="trigger" :href="productUrl">
      {{ showMoreLabel }}
    </a>
    <template v-else-if="hasOverflow">
      <button
        v-if="!isExpanded"
        class="trigger"
        type="button"
        :aria-label="$t('product-info-sections.additional-attributes')"
        :aria-expanded="'false'"
        @click="toggleMoreDetails()"
      >
        {{ showMoreLabel }}
      </button>
      <button
        v-else
        class="trigger"
        type="button"
        :aria-label="$t('product-info-sections.less-attributes')"
        :aria-expanded="'true'"
        @click="toggleMoreDetails()"
      >
        {{ $t('product-info-sections.less-attributes') }}
      </button>
    </template>
  </div>
</template>

<script>
import { getLinesWithAttributeLinks } from 'Libs/helpers/attribute-catalog-search';
import attributeOverflowMixin from 'Libs/mixins/attributeOverflowMixin';

export default {
  name: 'PlpAttributes26',
  mixins: [attributeOverflowMixin],
  props: {
    regular: { type: Array, default: () => [] },
    defaultLimit: { type: Number, default: 7 },
    productUrl: { type: String, default: '' },
  },
  computed: {
    items() {
      return getLinesWithAttributeLinks({
        lines: this.regular,
        valueKey: 'info',
      });
    },
    showMoreLabel() {
      return this.$t('product-info-sections.additional-attributes-count', {
        '%count%': this.overflowCount,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'variables/breakpoints';

.plp-attributes-26 {
  @media #{$_mediaMDown} {
    margin-top: 0;
  }

  .attribute-line {
    font-size: var(--font-size-M);
    line-height: 1.4em;
    color: var(--color-nero);
    word-break: break-word;
  }

  .value-link {
    color: inherit;
    text-decoration: underline;
  }

  .trigger {
    display: inline-block;
    margin-top: var(--space-0--half);
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
    font-size: var(--font-size-M);
    color: var(--color-nero);
    text-decoration: underline;
  }
}
</style>
